import { ref } from "vue"
import {
  CompanyYouthMembershipPlanEnrollment,
  ListOpenYouthMembershipPlanEnrollmentsForMemberResponse,
  ConsentToYouthMembershipPlanEnrollmentResponse,
  ConsentToCompanyYouthMembershipPlanEnrollmentRequest,
  ListActiveYouthMembershipPlanEnrollmentsForMemberResponse
} from "@vitable/asclepius-api-client-ts"
import useAsclepius from "@common/composables/api/asclepius"

export function useListOpenYouthMembershipEnrollmentsForMember() {
  const { getYouthMembershipApi, callWithResponse, callResult } = useAsclepius()

  const openYouthMembershipEnrollments = ref<Array<CompanyYouthMembershipPlanEnrollment>>([])

  async function listOpenYouthMembershipEnrollmentsForMember(
    memberId: string
  ): Promise<Array<CompanyYouthMembershipPlanEnrollment>> {
    const data: ListOpenYouthMembershipPlanEnrollmentsForMemberResponse = await callWithResponse(() =>
      getYouthMembershipApi().listOpenYouthMembershipPlanEnrollmentsForMember({ memberId })
    )

    openYouthMembershipEnrollments.value = data.enrollments

    return data.enrollments
  }

  return {
    listOpenYouthMembershipEnrollmentsForMember,
    listOpenYouthMembershipEnrollmentsForMemberResult: callResult,
    openYouthMembershipEnrollments
  }
}

export function useListActiveYouthMembershipEnrollmentsForMember() {
  const { getYouthMembershipApi, callWithResponse, callResult } = useAsclepius()

  const activeYouthMembershipEnrollments = ref<Array<CompanyYouthMembershipPlanEnrollment>>([])

  async function listActiveYouthMembershipEnrollmentsForMember(
    memberId: string
  ): Promise<Array<CompanyYouthMembershipPlanEnrollment>> {
    const data: ListActiveYouthMembershipPlanEnrollmentsForMemberResponse = await callWithResponse(() =>
      getYouthMembershipApi().listActiveYouthMembershipPlanEnrollmentsForMember({ memberId })
    )

    activeYouthMembershipEnrollments.value = data.enrollments

    return data.enrollments
  }

  return {
    listActiveYouthMembershipEnrollmentsForMember,
    listActiveYouthMembershipEnrollmentsForMemberResult: callResult,
    activeYouthMembershipEnrollments
  }
}

export function useConsentToCompanyYouthMembershipPlan() {
  const { getYouthMembershipApi, callWithResponse, callResult } = useAsclepius()

  const activeCompanyYouthMembershipEnrollment = ref<CompanyYouthMembershipPlanEnrollment>()

  async function consentToCompanyYouthMembershipPlan(
    companyYouthMembershipPlanEnrollmentId: string,
    params: ConsentToCompanyYouthMembershipPlanEnrollmentRequest
  ): Promise<CompanyYouthMembershipPlanEnrollment> {
    const data: ConsentToYouthMembershipPlanEnrollmentResponse = await callWithResponse(() =>
      getYouthMembershipApi().consentToYouthMembershipPlanEnrollment({
        companyYouthMembershipPlanEnrollmentId,
        consentToCompanyYouthMembershipPlanEnrollmentRequest: params
      })
    )

    activeCompanyYouthMembershipEnrollment.value = data.enrollment

    return data.enrollment
  }

  return {
    consentToCompanyYouthMembershipPlan,
    consentToCompanyYouthMembershipPlanResult: callResult,
    activeCompanyYouthMembershipEnrollment
  }
}
